import React, { useState, useContext, useReducer } from 'react';
import {
  Row, Col,
  Divider,
  Button,
  Typography,
  Form, Input, Select, Tabs,
  Space,
  Checkbox,
  Collapse
} from 'antd';
import {
  CloseOutlined,
  CheckOutlined
} from '@ant-design/icons';
import { MasterContext } from '../../App';
import './style';
const { TabPane } = Tabs;
const { Paragraph } = Typography;
const { Panel } = Collapse;
export default React.forwardRef((props, ref) => {
  const { port, user, company, currentUser, authorities, currency, country, payment } = useContext(MasterContext);
  const { mode, buyer, onCloseCallback, onSaveCallback } = props;
  const [form] = Form.useForm();
  const [isReadonly, setReadonly] = useState(mode === 'edit');

  const [nameCN, setNameCN] = useState(buyer && buyer.name_cn);
  const [nameEN, setNameEN] = useState(buyer && buyer.name_en);
  const [nameNick, setNameNick] = useState(buyer && buyer.name_nick);
  const [paymentId, setPaymentId] = useState(buyer && buyer.payment_id);
  const [countryId, setCountryId] = useState(buyer && buyer.country_id);
  const [currencyId, setCurrencyId] = useState(buyer && buyer.currency_id);
  const [portId, setPortId] = useState(buyer && buyer.port_id);
  const [ownerId, setOwnerId] = useState(buyer && buyer.owner_id);
  const [companyId, setCompanyId] = useState(buyer && buyer.company_id);
  const [coOwner1Id, setCoOwner1Id] = useState(buyer && buyer.co_owner1_id);
  const [coOwner2Id, setCoOwner2Id] = useState(buyer && buyer.co_owner2_id);
  const [coOwner3Id, setCoOwner3Id] = useState(buyer && buyer.co_owner3_id);
  const [coOwner4Id, setCoOwner4Id] = useState(buyer && buyer.co_owner4_id);
  const [address, setAddress] = useState(buyer && buyer.address);
  const [tel, setTel] = useState(buyer && buyer.tel);
  const [contact, setContact] = useState(buyer && buyer.contact);
  const [email, setEmail] = useState(buyer && buyer.email);
  const [remark, setRemark] = useState(buyer && buyer.remark);
  const [goodsCode, setGoodsCode] = useState(buyer && buyer.goods_code);
  const [isInvoiceRequired, setInvoiceRequired] = useState((buyer && buyer.is_invoice_required) || true);
  const [isOnlyShipmark, setOnlyShipmark] = useState((buyer && buyer.is_only_shipmark) || false);
  const onSave = async () => {
    const values = await form.validateFields();
    if (onSaveCallback) {
      onSaveCallback(values);
    }
    setReadonly(true);
  }

  const onClose = async () => {
    try {
      if (onCloseCallback) {
        onCloseCallback();
      }
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const initValue = [
    { name: 'id', value: buyer && buyer.id },
    { name: 'name_en', value: nameEN },
    { name: 'name_cn', value: nameCN },
    { name: 'name_nick', value: nameNick },
    { name: 'currency_id', value: currencyId },
    { name: 'payment_id', value: paymentId },
    { name: 'contact', value: contact },
    { name: 'tel', value: tel },
    { name: 'email', value: email },
    { name: 'is_invoice_required', value: isInvoiceRequired },
    { name: 'is_only_shipmark', value: isOnlyShipmark },
    { name: 'country_id', value: countryId },
    { name: 'address', value: address },
    { name: 'port_id', value: portId },
    { name: 'remark', value: remark },
    { name: 'owner_id', value: ownerId },
    { name: 'company_id', value: companyId },
    { name: 'co_owner1_id', value: coOwner1Id },
    { name: 'co_owner2_id', value: coOwner2Id },
    { name: 'co_owner3_id', value: coOwner3Id },
    { name: 'co_owner4_id', value: coOwner4Id },
    { name: 'goods_code', value: goodsCode }
  ]

  const filteredUser = user.filter(x => x.category_id < 3);

  return (
    <Form style={{ padding: '1rem' }} form={form} preserve={false} onFinish={onSave} fields={initValue}>
      <Row>
        <Col span={12}>
          <Form.Item hidden={true} name="id" >
            <Input />
          </Form.Item>
          <Form.Item label="客户名称(英文)" name="name_en" rules={[{ required: true, message: '请输入客户英文名称!' }]}>
            <Input
              autocomplete="off"
              disabled={isReadonly}
              size="small"
              placeholder="请输入英文客户名称"
              onChange={(e) => setNameEN(e.target.value)}
            />
          </Form.Item>
          <Form.Item label="客户名称(中文)" name="name_cn" rules={[{ required: true, message: '请输入客户中文名称!' }]}>
            <Input
              autocomplete="off"
              disabled={isReadonly}
              size="small"
              placeholder="请输入中文客户名称"
              onChange={(e) => setNameCN(e.target.value)}
            />
          </Form.Item>
          <Form.Item label="结算货币(默认)" name="currency_id" rules={[{ required: true, message: '请选择结算货币!' }]}                            >
            <Select
              onChange={(value) => setCurrencyId(value)}
              disabled={isReadonly}
              placeholder="请选择结算货币"
              size="small" >
              {currency.map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {`${item.code} - (${item.name})`}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="支付方式(默认)" name="payment_id" rules={[{ required: true, message: '请选择支付方式!' }]}                            >
            <Select
              onChange={(value) => setPaymentId(value)}
              disabled={isReadonly}
              placeholder="请选择支付方式"
              size="small" >
              {payment.map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {`${item.name_en} ${item.name_cn}`}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="　  客户产品代码" name="goods_code">
            <Input
              autocomplete="off"
              onChange={(e) => setGoodsCode(e.target.value)}
              disabled={isReadonly}
              placeholder="请输入客户产品代码，空代表无代码"
              size="small">
            </Input>
          </Form.Item>
          <Form.Item label="联系人" name="contact" rules={[{ required: true, message: '请输入客户联系人!' }]}                            >
            <Input
              autocomplete="off"
              onChange={(e) => setContact(e.target.value)}
              disabled={isReadonly}
              placeholder="请输入客户联系人"
              size="small"></Input>
          </Form.Item>
          <Form.Item label="电　话" name="tel" rules={[{ required: true, message: '请输入客户电话!' }]}                            >
            <Input
              autocomplete="off"
              onChange={(e) => setTel(e.target.value)}
              disabled={isReadonly}
              placeholder="请输入客户电话"
              size="small">
            </Input>
          </Form.Item>
          <Form.Item label="邮　箱" name="email" rules={[{ required: true, message: '请输入邮箱(aaa@aa.com,bbb@bb.com,ccc@cc.com)!' }]}                            >
            <Input
              autocomplete="off"
              onChange={(e) => setEmail(e.target.value)}
              disabled={isReadonly}
              placeholder="aaa@aa.com,bbb@bb.com,ccc@cc.com,... 多个邮箱以分号隔开填写"
              size="small">
            </Input>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="客户代号" name="name_nick" rules={[{ required: true, message: '请输入客户代号!' }]}>
            <Input
              autocomplete="off"
              disabled={isReadonly}
              size="small"
              placeholder="请输入客户代号"
              onChange={(e) => setNameNick(e.target.value)}
            />
          </Form.Item>
          <Form.Item label="所属国家" name="country_id" rules={[{ required: true, message: '请选择客户所属国家!' }]}>
            <Select
              onChange={(value) => setCountryId(value)}
              size="small"
              showSearch="true"
              disabled={isReadonly}
              placeholder="请选择客户所属国家"
            >
              {country.map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name_en}-{item.name_cn}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="详细地址" name="address" rules={[{ required: true, message: '请选择客户详细地址!' }]}>
            <Input.TextArea
              autocomplete="off"
              onChange={(e) => setAddress(e.target.value)}
              disabled={isReadonly}
              size="small"
              placeholder="请选择客户详细地址"
              autoSize={{ minRows: 4, maxRows: 4 }}
            />
          </Form.Item>
          <Form.Item label="默认港口" name="port_id" rules={[{ required: true, message: '请选择客户默认港口!' }]}>
            <Select
              disabled={isReadonly}
              size="small"
              showSearch="true"
              placeholder="请选择客户默认港口"
              onChange={(value) => setPortId(value)}
            >
              {port.filter(x => x.country_id === countryId).map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name_en}-{item.name_cn}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="备　　注" name="remark" rules={[{ required: true, message: '请输入备注!' }]}>
            <Input.TextArea
              size="small"
              disabled={isReadonly}
              onChange={(e) => setRemark(e.target.value)}
              placeholder="请输入备注"
              autoSize={{ minRows: 3, maxRows: 3 }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Form.Item label={<strong>是否需要报关Invoice</strong>} valuePropName="checked" name="is_invoice_required">
          <Checkbox onChange={(e) => setInvoiceRequired(e.target.checked)} disabled={isReadonly} />
        </Form.Item>
        <Form.Item label={<strong>发货仅需要唛头</strong>} valuePropName="checked" name="is_only_shipmark">
          <Checkbox onChange={(e) => setOnlyShipmark(e.target.checked)} disabled={isReadonly} />
        </Form.Item>
      </Row>
      <Divider style={{ margin: '1rem 0' }} />
      <Row>
        <Col span={12}>
          <Form.Item label="所属业务员" name="owner_id" rules={[{ required: true, message: '请选择所属业务员!' }]}                            >
            <Select
              disabled={isReadonly}
              size="small"
              showSearch="true"
              placeholder="请选择所属业务员"
              onChange={(value) => setOwnerId(value)}
              style={{ width: '100%' }}
            >
              {filteredUser.map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="所属业务公司" name="company_id" rules={[{ required: true, message: '请选择所属业务公司!' }]}                            >
            <Select
              disabled={isReadonly}
              size="small"
              showSearch="true"
              placeholder="请选择所属业务公司"
              onChange={(value) => setCompanyId(value)}
              style={{ width: '100%' }}
            >
              {company.map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name_cn}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <Form.Item label="协作业务员1" name="co_owner1_id" >
            <Select
              allowClear={true}
              disabled={isReadonly}
              size="small"
              showSearch="true"
              placeholder="协作业务员1"
              onChange={(value) => setCoOwner1Id(value)}
            >
              {filteredUser.filter(x => x.id != ownerId).map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="协作业务员2" name="co_owner2_id" >
            <Select
              allowClear={true}
              disabled={isReadonly}
              size="small"
              showSearch="true"
              placeholder="协作业务员2"
              onChange={(value) => setCoOwner2Id(value)}
            >
              {filteredUser.filter(x => x.id != ownerId && x.id != coOwner1Id).map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="协作业务员3" name="co_owner3_id" >
            <Select
              allowClear={true}
              disabled={isReadonly}
              size="small"
              showSearch="true"
              placeholder="协作业务员3"
              onChange={(value) => setCoOwner3Id(value)}
            >
              {filteredUser.filter(x => x.id != ownerId && x.id != coOwner1Id && x.id != coOwner2Id).map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="协作业务员4" name="co_owner4_id" >
            <Select
              allowClear={true}
              disabled={isReadonly}
              size="small"
              showSearch="true"
              placeholder="协作业务员4"
              onChange={(value) => setCoOwner4Id(value)}
            >
              {filteredUser.filter(x => x.id != ownerId && x.id != coOwner1Id && x.id != coOwner2Id && x.id != coOwner3Id).map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Divider style={{ margin: '1rem 0' }} />
      <div className="page-footer">
        <div></div>
        <Space size="large">
          {onClose && <Button onClick={onClose} icon={<CloseOutlined />}>关 闭</Button>}
          {
            !isReadonly && <div style={{ display: 'flex', alignItems: 'center' }}>
              {(authorities.find(x => x === 'create_buyer' || x === 'edit_buyer') || currentUser.category_id === 1) && <Button htmlType="submit" type="primary" icon={<CheckOutlined />}>保 存</Button>}
            </div>
          }
          {
            isReadonly && <div style={{ display: 'flex', alignItems: 'center' }}>
              {(authorities.find(x => x === 'create_buyer' || x === 'edit_buyer') || currentUser.category_id === 1) && <Button onClick={() => setReadonly(false)} type="primary" icon={<CheckOutlined />}>编 辑</Button>}
            </div>
          }
        </Space>
      </div>
    </Form>
  )
});
